export enum PayFlowTransactionTypeEnum {
  authorization = 'A',
  balanceInquiry = 'B',
  creditRefund  = 'C',
  delayedCapture = 'D',
  voiceAuthorization = 'F',
  inquiry = 'I',
  rateLookup = 'K',
  dataUpload = 'L',
  duplicateTransaction = 'N',
  sale = 'S',
  void = 'V'
}
